<template>
	<div class="lang-nav">
		<nuxt-link
			v-for="item in items"
			:key="`${item.filename}-${item.language}`"
			:to="`${item.filename}`"
			@click="$emit('hideMenu')"
		>
			<span>{{ item.language }}</span>
		</nuxt-link>
	</div>
</template>

<script setup>
defineProps({
	items: {
		type: Array,
		required: true,
	},
});

defineEmits(['hideMenu']);
</script>

<style scoped lang="scss">
.lang-nav {
	display: flex;
	flex-flow: row wrap;
	margin: 10px 0 0;
	font-size: 14px;

	a {
		color: #f7f5eb;
		text-transform: uppercase;
		text-decoration: none;

		&:first-child::after {
			content: '';
			width: 48px;
			height: 1px;
			margin: 0 10px 3px;
			background: #a67f38;
			display: inline-block;
		}

		&.active {
			font-weight: 700;
		}
	}
}

.popup .lang-nav {
	a:first-child::after {
		background-color: #6689c5;
	}

	a {
		color: #555;
	}
}

@media (max-width: 900px) {
	footer .lang-nav {
		justify-content: center;
	}
}

@media (max-width: 600px) {
	.lang-nav {
		width: 100%;
		margin: 10px 0 0;
	}
}
</style>
